import React, { useState, useEffect } from 'react';
import Slider from 'react-slick'; // Sliderコンポーネントをインポート
import { Helmet } from 'react-helmet-async'; // ★これと
import "./Style/loadingAnimation.css";
import Loading from './Loading';
import styled from 'styled-components';
import Topics from './Topics';
import DocumentRequest from './DocumentRequest';
import Access from './Access';
import Approach from './Approach';
// import Mentenance from './Mentenance';
import { device } from '../MainContents/Style/StyleDevice';
import topImagePc2 from "../../img/highSchoolBnr.png";
import topImageSp2 from "../../img/highSchoolBnr.png";
import topWinter from "../../img/winter.jpg";
import nijiTaisaku from "../../img/nijitaisaku.jpg";
import topImagePc from "../../img/top3.png";
import topImageSp from "../../img/top3.png";
import daiitiSetumeikai from "../../img/daiitiSetumeikai.png";

// スタイル定義は変更なし
const DivTop = styled.div`
  margin-top: 170px;
  @media ${device.mobile}{
    margin-top: 80px;
  }
`;

const HeadingTitle = styled.div`
  text-align: left;
  font-size: 55px;
  font-weight: 500;
  line-height: 1.5em;
  color: #9b003f;
  margin-bottom: 30px;
  @media ${device.mobile} {
    font-size: 26px;
    margin-bottom: 10px;
    padding-left: 20px;
    padding-top: 18px;
  }
`;

// ▼▼▼ 追加：お知らせ用のスタイル ▼▼▼
const NoticeContainer = styled.div`
  background-color: #fff9f9;
  border: 2px solid #e53e3e;
  border-radius: 8px;
  padding: 24px 28px;
  margin: 0 auto 35px;
  max-width: 900px;
  box-shadow: 0 4px 12px rgba(229, 62, 62, 0.08);

  @media ${device.mobile} {
    padding: 16px;
    margin: 10px auto 25px;
    width: 92%;
  }
`;

const NoticeTitle = styled.h2`
  color: #c53030;
  font-size: 20px;
  font-weight: 700;
  text-align: center;
  margin: 0 0 16px 0;
  letter-spacing: 0.03em;

  @media ${device.mobile} {
    font-size: 16px;
    margin-bottom: 12px;
  }
`;

const NoticeText = styled.p`
  font-size: 15px;
  line-height: 1.8;
  color: #333333;
  margin: 0 0 12px 0;
  text-align: left;

  @media ${device.mobile} {
    font-size: 13.5px;
    line-height: 1.7;
  }
`;

const NoticeHighlight = styled.div`
  background-color: #fff0f0;
  border-left: 4px solid #e53e3e;
  padding: 10px 14px;
  margin: 12px 0;
  font-size: 14.5px;
  line-height: 1.7;
  color: #4a5568;

  strong {
    color: #9b2c2c;
    font-weight: 700;
  }

  @media ${device.mobile} {
    font-size: 13px;
    padding: 8px 10px;
  }
`;

const NoticePhoneBox = styled.div`
  margin-top: 18px;
  padding-top: 14px;
  border-top: 1px dashed #feb2b2;
  text-align: center;
`;

const NoticePhoneLabel = styled.div`
  font-size: 13px;
  color: #718096;
  margin-bottom: 4px;
  font-weight: 600;
`;

const NoticePhoneLink = styled.a`
  display: inline-block;
  font-size: 24px;
  font-weight: 800;
  color: #c53030;
  text-decoration: none;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.8;
    text-decoration: underline;
  }

  @media ${device.mobile} {
    font-size: 20px;
  }
`;

const PhoneIcon = styled.span`
  font-size: 20px;
  vertical-align: middle;
  margin-right: 4px;
`;
// ▲▲▲ 追加：お知らせ用のスタイルここまで ▲▲▲

const Main = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  // Sliderのセッティング
  // 今回はトップ画像をスライドさせるため、既存のsettingsを使用
  var settings = {
    dots: true, // ドットのナビゲーションを表示
    infinite: true, // 無限ループ
    speed: 500, // スライドの速度
    slidesToShow: 1, // 一度に表示するスライドの数
    slidesToScroll: 1, // 一度にスクロールするスライドの数
    autoplay: true, // 自動再生を有効にする
    autoplaySpeed: 3000, // 自動再生の間隔（ミリ秒）
    arrows: false, // 左右の矢印ナビゲーションを非表示（必要ならtrueに）
  };

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // 画面幅に応じて表示する画像を切り替えるロジック
  // スライダーに複数の画像を持たせるため、配列で管理します
  const topImagesPc = [
    // { src:  topImagePc , link: "/kouza/"},
    { src:  daiitiSetumeikai, link: "/mail/openCampusMail.php" },
    { src:  topImagePc2, link: "/TosayobiHighSchool" }
    
  ];
  const topImagesSp = [
    // { src: topImageSp , link: "/kouza/" },
    { src:  daiitiSetumeikai, link: "/mail/openCampusMail.php" },
    { src: topImageSp2, link: "/TosayobiHighSchool" }

  ];
  // const topImagesPc = [topSummer]; // PC用のスライド画像配列
  // const topImagesSp = [topSummer]; // スマホ用のスライド画像配列

  // 現在の画面幅に応じた画像配列を選択
  const currentImages = windowWidth <= 768 ? topImagesSp : topImagesPc;

  return (
    <DivTop>
      <Loading />
      {/* <Mentenance /> */}
            {/* ★ここからHelmetの記述を追加します */}
            <Helmet>
                <title>土佐塾予備校 高知での実績No.1予備校</title> {/* ←ここに希望するタイトルを設定 */}
                <meta name="description" content="JR高知駅から徒歩5分と最高の交通アクセス！！ 本校は県内唯一の学校法人の予備校です。 公共交通機関の学割制度を利用できるので、経済的に負担も大幅に軽減できます。" />
                {/* 必要であれば、OGPタグなどもここに追加できます */}
                {/* <meta property="og:title" content="TOSAYOBI高等学院" /> */}
                {/* <meta property="og:description" content="高知の通信制高校です。" /> */}
                {/* <meta property="og:url" content="http://localhost:3000/TosayobiHighSchool" /> */}
                {/* <meta property="og:image" content="ここにOGP画像のURL" /> */}
            </Helmet>

      {/* ▼▼▼ 追加：重要なお知らせエリア ▼▼▼ */}
      <NoticeContainer>
        <NoticeTitle>【重要】お問い合わせフォームの一時停止について</NoticeTitle>
        
        <NoticeText>
          「PHPにおける重大な脆弱性の確認」を受けて、予防的メンテナンスとして当サイトの「お問い合わせフォーム」を一時停止しております。
        </NoticeText>

        {/* <NoticeHighlight>
          本対応はシステムの安全確保を目的とした予防措置であり、<strong>当学院における不正アクセスや個人情報の漏洩などの被害が発生したことによるものではございません。</strong>
        </NoticeHighlight> */}

        <NoticeText>
          各種ご案内ページの閲覧は通常通りご利用いただけます。<br />
          お急ぎのご用件・お問い合わせにつきましては、下記までお電話にてご連絡くださいますようお願い申し上げます。
        </NoticeText>

        <NoticePhoneBox>
          <NoticePhoneLink href="tel:0888831065">
            <PhoneIcon aria-hidden="true">📞</PhoneIcon> 088-883-1065
          </NoticePhoneLink>
        </NoticePhoneBox>
      </NoticeContainer>
      {/* ▲▲▲ 追加：重要なお知らせエリアここまで ▲▲▲ */}

      {/* Sliderコンポーネントで画像をラップ */}
      <Slider {...settings}>
        {currentImages.map((imageObj, index) => (
          <div key={index}>
            <a href={imageObj.link}>
              <img src={imageObj.src} alt={`Top Image ${index + 1}`} className="w-full" />
            </a>
          </div>
        ))}
      </Slider>
      
      <Topics />
      <Approach />
      <DocumentRequest />
      <Access />
    </DivTop>
  );
}

export default Main;